<template>
    <notifications :group="group" class="notification general" position="top right">
        <template v-slot:body="props" >
            <div class="vue-notification-template vue-notification">
                <a class="notification-title">
                    <spinner
                        class="spinner-wrapper"
                        size="small" v-if="props.item.data.spinner"
                        line-fg-color="#009ed1"
                        :speed="1.2"
                    />
                    <span class="notification-title-text" v-if="props.item.title">
                        {{props.item.title}}
                    </span>
                </a>
                <a class="close" @click="props.close">
                <i class="fa fa-fw fa-close"></i>
                </a>
                <div  class="notification-content" v-html="props.item.text">
                </div>
            </div>
        </template>
    </notifications>
</template>
<script>
export default {
    props: ['group'],
    name: 'Notification',
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;
</style>
